/* eslint-disable */ import { assertString, memoEval, textValueComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const pricingSettingsComponents = [
    attachAdminComponent.withComponent(textValueComponent, 'data', true).withEntity('PricingSettings').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.data
        ], (data)=>({
            value: data
        })), (state)=>{
        assertString(state.value);
        return {
            data: state.value
        };
    })
];

//# sourceMappingURL=pricing-settings.js.map